var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.$t('components.thg.thgBillingOperation.title'),
      "actions": _vm.actions,
      "breadCrumbs": _vm.breadCrumbs
    },
    on: {
      "actionClicked": _vm.processAction
    }
  }), _c('v-card-actions', [_vm.operationLoading ? _c('v-skeleton-loader', {
    staticClass: "mx-auto",
    attrs: {
      "type": "list-item-two-line,list-item-two-line,list-item-two-line"
    }
  }) : _vm.operation && !_vm.loadingFailed ? _c('div', [_vm.operation.status ? _c('span', [_c('small', [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingOperation.status")) + " ")]), _c('br'), !_vm.isOperationFinished && _vm.isCancellationRequested ? _c('span', [_vm._v(" " + _vm._s(_vm.operation.status) + " (" + _vm._s(_vm.$t("components.operation.OperationDetail.cancellationRequested")) + ") ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.operation.status) + " ")]), _c('br')]) : _vm._e(), _vm.operation.type ? _c('span', [_c('small', [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingOperation.type")) + " ")]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.operation.type))]), _c('br')]) : _vm._e(), _vm.operation.message ? _c('span', [_c('small', [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingOperation.message")) + " ")]), _c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.operation.message)
    }
  }), _c('br')]) : _vm._e(), _vm.operation.error && Object.keys(_vm.operation.error).length !== 0 ? _c('span', [_c('small', [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingOperation.error")) + " "), _c('br')]), _c('span', [_vm.operation.error.type ? _c('span', [_c('small', {
    staticClass: "ml-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingOperation.errorType")) + " ")]), _c('br'), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.operation.error.type))]), _c('br')]) : _vm._e(), _vm.operation.error.message ? _c('span', [_c('small', {
    staticClass: "ml-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingOperation.errorMessage")) + " ")]), _c('br'), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.operation.error.message))]), _c('br')]) : _vm._e(), _vm.operation.error.details && _vm.operation.error.details.trim() ? _c('span', [_c('small', {
    staticClass: "ml-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingOperation.errorDetails")) + " ")]), _c('br'), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.operation.error.details))]), _c('br')]) : _vm._e()])]) : _vm._e(), _vm.operation.body ? _c('span', [_c('small', [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingOperation.body")) + " ")]), _c('br'), _vm._l(Object.keys(_vm.operation.body), function (key) {
    return _c('span', {
      key: key,
      staticClass: "ml-2"
    }, [_c('small', [_vm._v(" " + _vm._s(key) + " ")]), _c('br'), !_vm.isObject(_vm.operation.body[key]) ? _c('span', {
      staticClass: "ml-2"
    }, [_vm._v(_vm._s(_vm.operation.body[key]) + " "), _c('br')]) : _c('span', _vm._l(Object.keys(_vm.operation.body[key]), function (key2) {
      return _c('span', {
        key: key2,
        staticClass: "ml-4"
      }, [_c('small', [_vm._v(" " + _vm._s(key2) + " ")]), _c('br'), _c('span', {
        staticClass: "ml-4"
      }, [_vm._v(" " + _vm._s(_vm.getValue(_vm.operation.body[key], key2)) + " ")]), _c('br')]);
    }), 0)]);
  })], 2) : _vm._e(), _vm.detailedDateCreated ? _c('span', [_c('small', [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingOperation.created")) + " ")]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.detailedDateCreated))]), _c('br')]) : _vm._e(), _vm.isOperationDownloadable ? _c('span', [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "loading": _vm.downloadUrlLoading,
      "color": "success"
    },
    on: {
      "click": _vm.openCsv
    }
  }, [_vm._v("Download")])], 1) : _vm._e(), _vm.getShowCsvResults(_vm.operation) ? _c('span', [!_vm.multiUrls.length ? _c('v-btn', {
    staticClass: "mt-2",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "loading": _vm.loadingThgAllCsvResults,
      "color": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.loadThgAllCsvResults(_vm.operation.id);
      }
    }
  }, [_vm._v(" Results ")]) : _vm._e(), _vm._l(_vm.multiUrls, function (multiUrl) {
    return _c('div', {
      key: multiUrl
    }, [_c('v-btn', {
      staticClass: "mt-2",
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "color": "success"
      },
      on: {
        "click": function click($event) {
          return _vm.openCsvByLink(multiUrl.url);
        }
      }
    }, [_vm._v(" " + _vm._s(multiUrl.name) + " ")])], 1);
  })], 2) : _vm._e()]) : _c('div', [_c('latest-entries-card-empty', {
    staticClass: "mt-5 mb-5"
  })], 1)], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isCancelDialogActive,
      "title": _vm.$t('components.operation.OperationDetail.cancellationTitle'),
      "subtitle": _vm.$t('components.operation.OperationDetail.cancellationSubtitle'),
      "rightLoading": _vm.isCancellationLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isCancelDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isCancelDialogActive = $event;
      },
      "leftClick": function leftClick($event) {
        _vm.isCancelDialogActive = false;
      },
      "rightClick": _vm.cancel
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }